import type { AxiosRequestConfig } from 'axios';

export const ORGANIZATION_HEADER = 'X-Organization-Id';

/**
 * 組織を切り替えた後も遅延リクエストが元の組織スコープで飛ぶよう、
 * リクエスト単位で X-Organization-Id を固定する config を返す。
 * 未指定なら既定ヘッダー（選択中組織）を使う。
 */
export function organizationIdConfig(
  organizationId: number | null | undefined,
): AxiosRequestConfig | undefined {
  if (organizationId === null || organizationId === undefined) return undefined;
  return { headers: { [ORGANIZATION_HEADER]: String(organizationId) } };
}
